import { NavigateFunction } from "react-router-dom";
import { TopicSteps } from "../entities/topic";

export const currentScreen = (
  currentStep: TopicSteps,
  navigate: NavigateFunction,
  topicId: string
) => {
  console.log("currentStep", topicId);

  switch (currentStep) {
    case TopicSteps.PLAYERS_TO_JOIN:
      return navigate(`/waiting?topicId=${topicId}`);
    case TopicSteps.CREATOR_TO_CONTINUE:
      return navigate(`/correction?topicId=${topicId}`);
    case TopicSteps.CREATOR_TO_VALIDATE:
      return navigate(`/correction?topicId=${topicId}`);
    case TopicSteps.ANSWERING:
      return navigate(`/question?topicId=${topicId}`);
    case TopicSteps.FINISHED:
      return navigate(`/winners?topicId=${topicId}`);
    default:
      return;
  }
};
